import Input from "components/input";
import { regPwd } from "components/utils/comm";
import { useLayoutEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { IoMdEye } from "react-icons/io";
import { PiEyeClosed } from "react-icons/pi";
import { useResetPwd } from "./handlers";

export default function ResetPwdPage() {
  const { t } = useTranslation();
  const formRef = useRef<HTMLFormElement>(null);
  const txtRef = useRef<HTMLHeadingElement>(null);
  const [lgnPwd, setLgnPwd] = useState("");
  const [isShow, setIsShow] = useState({
    lgnPwd: false,
    check: false,
  });

  const { onSubmit } = useResetPwd();

  useLayoutEffect(() => {
    if (txtRef.current) {
      txtRef.current.innerHTML = t("reset_pass_reset_txt_1");
    }
  }, [t]);

  return (
    <>
      <form
        id="signup-pwd"
        ref={formRef}
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit({ form: e.currentTarget, lgnPwd });
        }}
      >
        <h2>{t("reset_pass_ttl")}</h2>
        <div className="pt-3">
          <h4 className="leading-[24px] dashed-b-1 pb-4" ref={txtRef} />
        </div>
        <ul className="lex col gap-3 pt-6">
          <li className="relative">
            <span
              className="mt-[-10px] absolute right-[10px] top-[35px]"
              onClick={() => {
                setIsShow({
                  ...isShow,
                  lgnPwd: !isShow.lgnPwd,
                });
              }}
            >
              {!isShow.lgnPwd && <PiEyeClosed size={16} />}
              {isShow.lgnPwd && <IoMdEye size={16} />}
            </span>
            <label htmlFor="">{t("txt_pass_cmm")}</label>
            <Input
              type={isShow.lgnPwd ? "text" : "password"}
              name="lgnPwd"
              className="w-full bg-transparent border-0 border-b-1"
              required
              data-type="C"
              onBlur={(e) => {
                const value = e.currentTarget.value;
                if (!regPwd.test(value)) {
                  e.currentTarget.style.color = "red";
                  e.currentTarget.setCustomValidity(
                    "정확환 형식의 비밀번호를 입력하세요."
                  );
                  return;
                }
                if (regPwd.test(value)) {
                  e.currentTarget.style.color = "#010101";
                }
              }}
              onChange={(e) => {
                setLgnPwd(e.currentTarget.value);
              }}
              validatyTxt="비밀번호를 입력하여 주세요."
            />
          </li>
          <li className="relative">
            <span
              className="mt-[-10px] absolute right-[10px] top-[35px]"
              onClick={() => {
                setIsShow({
                  ...isShow,
                  check: !isShow.check,
                });
              }}
            >
              {!isShow.check && <PiEyeClosed size={16} />}
              {isShow.check && <IoMdEye size={16} />}
            </span>
            <label htmlFor="">{t("txt_pass_check_cmm")}</label>
            <Input
              type={isShow.check ? "text" : "password"}
              name="lgnPwd_check"
              className="w-full bg-transparent border-0 border-b-1"
              required
              dataTyp="R"
              //   data-type="C"
              onBlur={(e) => {
                const value = e.currentTarget.value;
                if (lgnPwd !== value) {
                  e.currentTarget.style.color = "red";
                  // e.currentTarget.setCustomValidity(
                  //   "비밀번호가 일치하지 않습니다."
                  // );
                  return;
                }
                if (lgnPwd === value) {
                  e.currentTarget.style.color = "#010101";
                  // e.currentTarget.setCustomValidity("");
                }
              }}
              validatyTxt="비밀번호가 일치하지 않습니다."
            />
          </li>
        </ul>
        <div className="flex justify-center pt-[40px]">
          <button type="submit" className="btn bg-red-400">
            {t("btn_confirm")}
          </button>
        </div>
      </form>
    </>
  );
}
